// extracted by mini-css-extract-plugin
export var measureBox = "_b0-0";